module.exports = __webpack_public_path__ + "static/favicon-96x96-d58009283284bccdc9df181ff1e67c15.png";